export const favoriteFilterKeys = {
	affiliateIds: 'favAdmFFAffiliateIds',
	trackerIds: 'favAdmFFTrackerIds',
	brandCodes: 'favAdmFFBrandCodes',
	statuses: 'favAdmFFStatuses',
	brandCurrencies: 'favAdmFFBrandCurrencies',
}

export const reportStorageProps = {
	type: 'flat-fee',
	target: 'filters',
	tableSettingsTarget: 'table-settings',
	savedReportTarget: 'flat-fee-settings',
	savedReportFavoritesTarget: 'flat-fee-favorites',
	savedReportDefaultTarget: 'flat-fee-default',
	exceptions: ['sent_from', 'sent_to'],
	exceptionsIds: ['affiliateIds', 'trackerIds', 'brandCodes', 'statuses', 'brandCurrencies'],
	exceptionsStr: ['anid', 'playerId', 'source1', 'source2', 'source3', 'source4', 'source5'],
	maxFavoriteReports: 10,
}

export const statusOptions = [
	{
		id: 0,
		value: 'annulled'
	},
	{
		id: 1,
		value: 'active'
	},
	{
		id: 2,
		value: 'closed'
	},
]

export const paymentsTypeOptions = [
	{
		id: 'fixedPayment',
		value: 'fixedPayment'
	},
	{
		id: 'prePayment',
		value: 'prePayment'
	}
]